export interface DeliveryNoteDetailedReportDto {
	clientId?: number;
	endDate: Date;
	startDate: Date;
}

export class DeliveryNoteDetailedReportDto implements DeliveryNoteDetailedReportDto {
	constructor(data?: Partial<DeliveryNoteDetailedReportDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}